import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import userReducer from './reducers/userReducer'
import songReducer from './reducers/songReducer'
import playlistReducer from './reducers/playlistReducer'

const reducer = combineReducers({
  userState: userReducer,
  songState: songReducer,
  playlistState: playlistReducer
})

const initialState = {
  userState: {
    userInfo: localStorage.getItem('eclsusr') ? JSON.parse(localStorage.getItem('eclsusr')) : null
  }
}

const middleware = [thunk]

const store = createStore(reducer, initialState, composeWithDevTools(applyMiddleware(...middleware)))

export default store